import { Box, Flex, Text } from "@chakra-ui/layout";
import { PaginatedQuery } from "../../types/axios.types";
import { ReactNode } from "react";

export type ServerSideListElementProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
};

export type ServerSideListProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: PaginatedQuery<any>;
  template: (props: ServerSideListElementProps) => ReactNode;
  templateEmpty?: () => ReactNode;
  cardProps?: (props: ServerSideListElementProps) => object;
};

const ServerSideList = ({
  query,
  template,
  templateEmpty,
  cardProps,
}: ServerSideListProps) => {
  const page = 1;
  const size = 60;
  const label = "TYPE";
  const response = query(page, size, undefined, undefined, undefined);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dataToProps = (data: any) => {
    return {
      data,
    };
  };
  return (
    <Flex w="100%" justify="center" direction="column" alignItems="center">
      <Box w="100%" borderRadius="xl" backgroundColor="zinc.50" py="3px">
        <Flex px="24px" py="12px">
          <Text color="gray.500">{label}</Text>
        </Flex>

        <Box>
          {response &&
            response.data &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            response.data.map((element: any) => (
              <Box
                key={element.id}
                backgroundColor="white"
                boxShadow="sm"
                p="24px"
                m="3px"
                _first={{
                  borderTopRadius: "md",
                }}
                _last={{
                  borderBottomRadius: "md",
                }}
                {...(cardProps ? cardProps(dataToProps(element)) : {})}
              >
                {template(dataToProps(element))}
              </Box>
            ))}
          {response &&
            response.data &&
            response.data.length === 0 &&
            (templateEmpty ? (
              templateEmpty()
            ) : (
              <Flex
                direction="column"
                justify="center"
                alignItems="center"
                backgroundColor="white"
                borderRadius="xl"
                p="24px"
                m="4px"
                h="min(40vh, 400px)"
              >
                <Text
                  lineHeight="30px"
                  fontSize="20px"
                  fontWeight="600"
                  color="gray.900"
                >
                  Pas de donnée trouvée
                </Text>
                <Text
                  lineHeight="30px"
                  fontSize="12px"
                  fontWeight="200"
                  color="gray.400"
                >
                  Vous pouvez essayer avec une autre recherche
                </Text>
              </Flex>
            ))}
        </Box>
      </Box>
    </Flex>
  );
};

export default ServerSideList;
